import React from 'react';

import Buttons from './Buttons';
import { cgStartCard } from './data';
import ContactCard from './ContactCard';

function CardBody({
    data,
    gameStarted,
    startGame,
    skipQuestion,
    saveQuestionData,
    noMoreQuestions,
    toggleEndGame,
    toggleShowReviewAnswers,
}) {
    return (
        <div className="w-full h-full flex flex-col items-center justify-between py-8 bg-cirrusWhite">
            <div>
                <p className="text-center font-jazmin font-bold text-[30px]">{data.title}</p>
            </div>
            <div className="max-w-[80%] pt-2 pb-6">
                <p className="text-center">{data.subtitle}</p>
            </div>
            <ContactCard contactCard={data.contactCard} />
            <div className="mb-3">
                {!gameStarted
                    ? (
                        <button
                            type="button"
                            data-tooltip-id="tip"
                            title={data.buttons[0].text}
                            aria-label={data.buttons[0].text}
                            onClick={startGame}
                            className="border-[1px] w-full border-cleanSlate rounded-lg bg-cleanSlate flex items-center justify-center py-2 my-3 pt-[6px] mr-0"
                        >
                            <div className="flex items-center justify-center px-5 py-1">
                                {data.buttons[0].iconLeft && (
                                    <div className="pr-2">
                                        {data.buttons[0].iconLeft}
                                    </div>
                                )}
                                <p className={`font-medium text-${data.buttons[0].fontColor || 'cleanSlate'}`}>{data.buttons[0].label}</p>
                                {data.buttons[0].iconRight && (
                                    <div className="pl-2">
                                        {data.buttons[0].iconRight}
                                    </div>
                                )}
                            </div>
                        </button>
                    )
                    : (
                        <Buttons
                            data={gameStarted ? data : cgStartCard}
                            action={!noMoreQuestions ? saveQuestionData : toggleEndGame}
                            endGame={noMoreQuestions}
                        />
                    )}
            </div>
            {(gameStarted && !noMoreQuestions) && (
                <div>
                    <button
                        type="button"
                        data-tooltip-id="tip"
                        title="Skip for now"
                        aria-label="Skip for now"
                        onClick={skipQuestion}
                        className="text-progressBarBlue"
                    >
                        Skip for now
                    </button>
                </div>
            )}
            {noMoreQuestions && (
                <div>
                    <button
                        type="button"
                        data-tooltip-id="tip"
                        title="Review my answers"
                        aria-label="Review my answers"
                        onClick={toggleShowReviewAnswers}
                        className="text-progressBarBlue"
                    >
                        Review my answers
                    </button>
                </div>
            )}
        </div>
    );
}

export default CardBody;
